import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

/**
 * Toast Service - MDB5 Compatible Wrapper
 * Wraps ngx-toastr to provide MDB4-compatible API
 */
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) {}

  success(message: string, title?: string, options?: any) {
    this.toastr.success(message, title, {
      timeOut: options?.delay || 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true,
      positionClass: 'toast-top-right',
      ...options
    });
  }

  error(message: string, title?: string, options?: any) {
    this.toastr.error(message, title, {
      timeOut: options?.delay || 5000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true,
      positionClass: 'toast-top-right',
      ...options
    });
  }

  info(message: string, title?: string, options?: any) {
    this.toastr.info(message, title, {
      timeOut: options?.delay || 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true,
      positionClass: 'toast-top-right',
      ...options
    });
  }

  warning(message: string, title?: string, options?: any) {
    this.toastr.warning(message, title, {
      timeOut: options?.delay || 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true,
      positionClass: 'toast-top-right',
      ...options
    });
  }

  show(message: string, title?: string, options?: any) {
    this.toastr.show(message, title, {
      timeOut: options?.delay || 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true,
      positionClass: 'toast-top-right',
      ...options
    });
  }

  clear() {
    this.toastr.clear();
  }

  remove(toastId?: number) {
    if (toastId) {
      this.toastr.clear(toastId);
    }
  }
}
